import { connect, getIn } from 'formik';
import PropTypes from 'prop-types';

import { AdditionalInformation } from '@hivebrite/design-system/AdditionalInformation';

const Error = ({ formik, name, id }) => {
  const error = getIn(formik.errors, name);
  const touched = getIn(formik.touched, name) || formik.submitCount > 0;

  return touched && error ? (
    <AdditionalInformation type="error" id={id}>
      {error}
    </AdditionalInformation>
  ) : null;
};

Error.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string,
};

export default connect(Error);
